export default __webpack_public_path__ + "support.html";